export default class PassSection {
  title?: string | null
  content?: string | null

  constructor (title?: string, content?: string) {
    this.title = title || null
    this.content = content || null
  }
}
